import { defineComponent, reactive } from 'vue';
import { MainTitle, ReportTabList } from '@/components';
import { ApplianceChartContainer } from '@/containers';
export default defineComponent({
    name: 'HomeApplianceChart',
    components: {
        MainTitle,
        ReportTabList,
        ApplianceChartContainer,
    },
    setup() {
        const state = reactive({
            tabname: 'hourly',
            show: false,
        });
        state.show = true;
        return {
            state,
        };
    },
});
